export const contentType = "application/json"
export const mailerUrl = "https://us-central1-servicescheduler-af9f2.cloudfunctions.net/sendmail"
export const smsUrl = "https://us-central1-servicesms-df0dc.cloudfunctions.net/api/single"
export const smsAuthorization = "Basic dW5pdHh0Y2xpZW50MTpVSm1FajVIYUFNTHZlbDdpWFRoY1kyd2xXNEptbkpwOQ=="
export const twoFACode = "https://us-central1-servicescheduler-af9f2.cloudfunctions.net/send2faCode"
export const verifyCode = "https://us-central1-servicescheduler-af9f2.cloudfunctions.net/verify2FACode"
export const facebookAppId = "426394334582829"
export const facebookAppSecret = "132dfb74d38d599137944dd47ba8c441"
export const facebookSignInOptionId = "446576575852-msen13kalftcusqgnea2cate1qi4nhhu.apps.googleusercontent.com"
export const facebookSignInOptionSecret = "PksHFTrzphJ3Bg6O5-JgioPA"

// *************** development stage ***************
// export const stage = "_dev"
// export const clientUrl = "dev.aftersales.scinnova.com.ph"
// export const branchUrl = "dev.branch.aftersales.scinnova.com.ph"
// export const adminUrl = "dev.admin.aftersales.scinnova.com.ph"
// export const subAccount = "SC_O_IT"
// export const materialMaster = "https://nsjonah.scinnova.com.ph/restlet/material_master?productType=BRANDNEW"
// export const consumerKey = "67e10df831a44e610aede9423749401363e28bd52d1c5615952b4cbdb4f7b182"
// export const consumerSecret = "d7d8fac5228339bddc237e38060722a5ab334a2c8c5c5af6fea49bb54f103829"
// export const tokenId = "344d22b848a238144143d6af1db839356a8a9497b99ea61725f6aa6c63c9a45f"
// export const tokenSecret = "4a982c7162ad4993e691dc7ae5ecd3fe8d2e189b5f31f92c56c2b14b37522143"

// *************** staging stage ***************
export const stage = "_staging"
export const clientUrl = "staging.aftersales.scinnova.com.ph"
export const branchUrl = "staging.branch.aftersales.scinnova.com.ph"
export const adminUrl = "staging.admin.aftersales.scinnova.com.ph"
export const subAccount = "SC_O_Service"
export const materialMaster = "https://nsjonah-uat.scinnova.com.ph/restlet/material_master?productType=BRANDNEW"
export const consumerKey = "7ea11aa4df7f47f9d8077c6872fdb9d8adf71dc9040d010a7cefd57808ec4971"
export const consumerSecret = "854a1ba063886ae487c4a57b8a1aa3523634ceb9f5d7881d2451492d8c333763"
export const tokenId = "241de6004acbd1ac9078d3634f26d0ae51871eec458246845a22254ba848cd2f"
export const tokenSecret = "ddebd2de137f721d5545d1e924628d888f4bddc349cd5f9279a20f626c848c2e"

// *************** production stage ***************
// export const stage = "_prod"
// export const clientUrl = "service-scheduler.transcycle.com.ph"
// export const branchUrl = "branch.aftersales.scinnova.com.ph"
// export const adminUrl = "admin.aftersales.scinnova.com.ph"
// export const subAccount = "SC_O_Service"
// export const materialMaster = "https://nsjonah.scinnova.com.ph/restlet/material_master?productType=BRANDNEW"
// export const consumerKey = "67e10df831a44e610aede9423749401363e28bd52d1c5615952b4cbdb4f7b182"
// export const consumerSecret = "d7d8fac5228339bddc237e38060722a5ab334a2c8c5c5af6fea49bb54f103829"
// export const tokenId = "344d22b848a238144143d6af1db839356a8a9497b99ea61725f6aa6c63c9a45f"
// export const tokenSecret = "4a982c7162ad4993e691dc7ae5ecd3fe8d2e189b5f31f92c56c2b14b37522143"